<template>
  <div class="sports-tabs">
    <div class="sports-tabs-wrap">
      <ul class="tabs">
        <li
          v-for="(s, idx) in sportList"
          v-bind:key="idx"
          :class="[
            sportDetails[s].className,
            'no-select',
            { active: current_sport === s },
            { 'btn-disabled': !sportDetails[s].hasMatches },
          ]"
        >
          <a :href="getFirstNodeHref(s)">
            <span class="txt">{{ sportDetails[s].name }}</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { formatFullUrl } from "../../assets/js/common";
import { CFG_MODULES } from "../../assets/js/config";

export default {
  props: ["parentRoute", "eventChangeHandler"],
  data() {
    return {
      show_sport_tooltip: {
        1: false,
        2: false,
      },
    };
  },
  computed: {
    current_sport() {
      return this.$store.state.match_detail_store.current_sport;
    },
    sportList() {
      return this.$store.state.match_detail_store.sportList;
    },
    sportDetails() {
      return this.$store.state.match_detail_store.sportDetails;
    },
    match_data() {
      return this.$store.state.match_detail_store.match_data;
    },
    in_match_categories() {
      return this.$store.state.match_detail_store.in_match_categories;
    },
  },
  methods: {
    getFirstNodeHref(sport_id) {
      if (sport_id === this.current_sport) {
        return null;
      }

      let firstCatForSport = this.in_match_categories.find(
        (c) => c.sport_id === sport_id
      );
      if (firstCatForSport) {
        if (
          this.match_data &&
          this.match_data[firstCatForSport.category_id].length
        ) {
          let first_node = this.match_data[firstCatForSport.category_id].find(
            (e) => true
          );
          if (
            this.parentRoute === CFG_MODULES.MATCH_INFO.route &&
            sport_id == 2
          ) {
            return formatFullUrl(first_node, CFG_MODULES.LINEUP.route);
          } else {
            return formatFullUrl(first_node, this.parentRoute);
          }
        } else {
          return null;
        }
      } else {
        return null;
      }
    },
  },
};
</script>